"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.LogoLink = exports.LogoImage = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _Link = _interopRequireDefault(require("../../Link"));

var LogoImage = (0, _styled.default)(_rebass.Image)(function (_ref) {
  var height = _ref.height;
  return {
    display: 'block',
    width: 'auto',
    height: height
  };
});
exports.LogoImage = LogoImage;
var LogoLink = (0, _styled.default)(_Link.default)({
  // IE fix
  '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
    order: '1'
  },
  img: {
    width: '100%',
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) and (min-width: 576px)': {
      width: 'auto'
    }
  }
});
exports.LogoLink = LogoLink;
var _default = LogoImage;
exports.default = _default;